"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variant = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const loader_1 = require("./loader");
var Variant;
(function (Variant) {
    Variant["contained"] = "contained";
    Variant["outlined"] = "outlined";
    Variant["text"] = "text";
})(Variant = exports.Variant || (exports.Variant = {}));
const Content = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, auto);
  gap: 8px;
  align-items: center;
  justify-content: center;
`;
const Button = styled_components_1.default.button `
  height: ${({ size }) => {
    if (size === "medium")
        return "40px";
    return "72px";
}};
  min-width: ${({ size }) => {
    if (size === "medium")
        return "160px";
    return "240px";
}};
  padding: 6px 14px;
  font-weight: ${({ size }) => {
    if (size === "medium")
        return "500";
    return "700";
}};
  font-size: 14px;
  border-radius: 8px;
  border: 2px solid;
  transition: all 0.15s;
  cursor: ${({ isDisabled }) => {
    if (isDisabled)
        return "not-allowed";
    return "pointer";
}};
  color: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained": {
            return theme.white;
        }
        case "outlined":
        case "text": {
            if (isDanger)
                return theme.error.main;
            return theme.primary.main;
        }
    }
}};
  background: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained": {
            if (isDanger)
                return theme.error.main;
            return theme.primary.main;
        }
        case "outlined":
        case "text": {
            return "transparent";
        }
    }
}};
  border-color: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained":
        case "outlined": {
            if (isDanger)
                return theme.error.main;
            return theme.primary.main;
        }
        case "text": {
            if (isDanger)
                return "transparent";
            return "transparent";
        }
    }
}};
  pointer-events: ${({ isLoading, variant }) => isLoading && variant != "text" && "none"};
  &:hover {
    background: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained":
        case "outlined": {
            if (isDanger)
                return theme.error.light;
            return theme.primary.light;
        }
        case "text": {
            if (isDanger)
                return "transparent";
            return "transparent";
        }
    }
}};
    border-color: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained":
        case "outlined": {
            if (isDanger)
                return theme.error.light;
            return theme.primary.light;
        }
        case "text": {
            if (isDanger)
                return "transparent";
            return "transparent";
        }
    }
}};
    color: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained":
        case "outlined": {
            return theme.white;
        }
        case "text": {
            if (isDanger)
                return theme.error.light;
            return theme.primary.light;
        }
    }
}};
  }
  &:focus-visible {
    ${({ variant, isDanger, theme }) => {
    if (variant === "text") {
        return (0, styled_components_1.css) `
          border-bottom: solid 2px
            ${isDanger ? theme.error.main : theme.primary.main};
        `;
    }
    else {
        return (0, styled_components_1.css) `
          outline-offset: 2px;
          outline: solid 2px ${isDanger ? theme.error.main : theme.primary.main};
        `;
    }
}}
  }
  &:active {
    background: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained":
        case "outlined": {
            if (isDanger)
                return theme.error.main;
            return theme.primary.main;
        }
        case "text": {
            return "transparent";
        }
    }
}};
    border-color: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained":
        case "outlined": {
            if (isDanger)
                return theme.error.main;
            return theme.primary.main;
        }
        case "text": {
            return "transparent";
        }
    }
}};
    color: ${({ variant, isDanger, theme }) => {
    switch (variant) {
        case "contained":
        case "outlined": {
            return theme.white;
        }
        case "text": {
            if (isDanger)
                return theme.error.main;
            return theme.primary.main;
        }
    }
}};
  }
  &:disabled {
    color: ${({ theme }) => theme.neutral.main};
    background: ${({ variant, theme }) => {
    switch (variant) {
        case "contained": {
            return theme.neutral.light;
        }
        case "outlined":
        case "text": {
            return "transparent";
        }
    }
}};
    border-color: ${({ variant, theme }) => {
    switch (variant) {
        case "contained": {
            return theme.neutral.light;
        }
        case "outlined": {
            return theme.neutral.main;
        }
        case "text": {
            return "transparent";
        }
    }
}};
  }
`;
const RotaButton = (_a) => {
    var { children, variant = Variant.contained, isDanger = false, size = "medium", isLoading = false, isDisabled = false, iconLeft, iconRight } = _a, props = __rest(_a, ["children", "variant", "isDanger", "size", "isLoading", "isDisabled", "iconLeft", "iconRight"]);
    const columns = [iconLeft, children, iconRight].filter(item => !!item).length;
    return (react_1.default.createElement(Button, Object.assign({ variant: variant, isDanger: isDanger, size: size, isLoading: isLoading, disabled: isDisabled, isDisabled: isDisabled }, props), isLoading ? (react_1.default.createElement(loader_1.Loader, { variant: variant, isDanger: isDanger, isDisabled: isDisabled })) : (react_1.default.createElement(Content, { columns: columns },
        iconLeft && iconLeft,
        children,
        iconRight && iconRight))));
};
exports.default = RotaButton;
